export enum ApiRoutesDrivers {
  Drivers = "admin/drivers",
  OneDriver = "admin/drivers/one",
  DriverPriority = "admin/drivers/priority",
  DriverContacts = "contacts-list",
  DaysOff = "admin/days-off",
  Restore = "restore"
}

export * from "./driverStatuses";
export * from "./driverCertificates";
